import { Text } from '@chakra-ui/react';

export const ViewSectionPracticeTypes = (props) => {
  const { profile } = props;
  const { practitionerModalities } = profile;

  return (
    <div className='flex flex-col gap-5 p-[30px]'>
      <Text textStyle="h3">Therapy offered</Text>
      <div className='flex flex-wrap gap-4'>
        {practitionerModalities?.map((area) => (
          <p key={area.value} className='text-sm rounded-full font-bold bg-brand-off text-brand-alt px-4 py-2'>
            {area.label}
          </p>
        ))}
      </div>
    </div>
  );
};
